import { NOPING_GREEN, SHIELD_CYAN } from '../constants';

export function CircuitBg() {
  return (
    <div className='pointer-events-none absolute inset-0 overflow-hidden' aria-hidden='true'>
      <div className='absolute left-1/2 top-1/2 size-[600px] -translate-x-1/2 -translate-y-1/2 rounded-full opacity-10' style={{ background: `radial-gradient(circle, ${SHIELD_CYAN}40, transparent 70%)` }} />
      <div className='absolute inset-0 opacity-[0.015]' style={{ backgroundImage: `radial-gradient(${SHIELD_CYAN} 1px, transparent 1px)`, backgroundSize: '24px 24px' }} />
    </div>
  );
}

export function DangerDotsBg() {
  return (
    <div className='pointer-events-none absolute inset-0 overflow-hidden' aria-hidden='true'>
      <div className='absolute inset-0 opacity-[0.02]' style={{ backgroundImage: 'radial-gradient(#FF3B3B 1px, transparent 1px)', backgroundSize: '30px 30px' }} />
    </div>
  );
}

export function ShieldGlowBg() {
  return (
    <div className='pointer-events-none absolute inset-0 overflow-hidden' aria-hidden='true'>
      <div className='absolute inset-0' style={{ background: `radial-gradient(ellipse 70% 50% at 50% 50%, ${SHIELD_CYAN}08, transparent), radial-gradient(ellipse 50% 40% at 30% 70%, ${NOPING_GREEN}05, transparent)` }} />
    </div>
  );
}
